import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
  fetchKeyPosApi,
  fetchKeyPosById,
  createChildPosApi,
  updateKeyPosApi,
  filterKeyPosApi,
  fetchDynamicFieldControlApi,
} from "../../../api/endpoint";

function* getKeyPosSaga(action) {
  try {
    const _api = yield call(fetchKeyPosApi, action.payload);
    yield put(actions.setKeyPos(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* getKeyPosIdSaga(action) {
  try {
    const _api = yield call(fetchKeyPosById, action.payload);
    yield put(actions.setKeyPosById(..._api.data.results));

    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

function* updateKeyPosSaga(action) {
  try {
    const _api = yield call(updateKeyPosApi, action.payload);
    if (_api?.data?.success) {
      yield put(commonActions.setLoading(false));
      yield put(commonActions.setRedirect(true));
    }
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

function* createChildPosSaga(action) {
  try {
    const _api = yield call(createChildPosApi, action.payload);
    if (_api?.data?.success) {
      yield put(commonActions.setLoading(false));
      yield put(commonActions.setRedirect(true));
    }
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

function* filterKeyPosSaga(action) {
  try {
    const _api = yield call(filterKeyPosApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setKeyPos(_api.data.results));
      yield put(commonActions.setClearFilter(true));
    }
  } catch (error) {
    console.log(error);
  }
}

function* getDynamicFieldControlSaga(action) {
  try {
    const _api = yield call(fetchDynamicFieldControlApi, action.payload);
    yield put(actions.setDynamicFieldControls(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

export function* watchKeyPosSaga() {
  yield all([
    takeEvery(actionTypes.GET_KEY_POS, getKeyPosSaga),
    takeEvery(actionTypes.GET_KEY_POS_BY_ID, getKeyPosIdSaga),
    takeEvery(actionTypes.UPDATE_KEY_POS, updateKeyPosSaga),
    takeEvery(actionTypes.CREATE_CHILD_POS, createChildPosSaga),
    takeEvery(actionTypes.GET_FILTERED_KEYPOS, filterKeyPosSaga),
    takeEvery(actionTypes.GET_DYNAMIC_FIELD_CONTROL, getDynamicFieldControlSaga),
  ]);
}
